import { Button, Card, Col, ConfigProvider, DatePicker, Divider, Form, Input, message, Row, Tooltip } from "antd";
import { useAuth } from "../../components/ProtectedRoute/PrivateRoutes";
import { useEffect, useState } from "react";
import { editUserInfo, getUserInfo } from "../../components/action";
import Meta from "antd/es/card/Meta";
import dayjs from "dayjs";
import { PasswordChangeModal } from "../admin/components/modals/PassworChangeModal";
export default function ProfilePage() {
    const { authState } = useAuth();
    const { email, user_id } = authState?.userInfo;
    const [messageApi, contextHolder] = message.useMessage();
    const [user, setUser] = useState(null);
    const [edit, setEdit] = useState(false);
    const [passwordChangeModal, setPasswordChangeModal] = useState(false);
    const [form] = Form.useForm();
    const reload = async () => {
        await getUserInfo(user_id).then(res => {
            setUser(res);
        }).catch(err => {
            console.log(err);
            messageApi.error(err?.response?.data || 'ვერ მოხერხდა მონაცემების ჩამოტვირთვა');
        });
    }
    useEffect(() => {
        user_id && reload();
    }, [user_id]);
    useEffect(() => {
        if (user) {
            form.setFieldsValue({
                first_name: user?.first_name,
                last_name: user?.last_name,
                email: user?.email,
                dob: user?.dob ? dayjs(user?.dob) : null,
            });
        }
    }, [user]);

    const editProfileSave = async () => {
        editUserInfo(user_id, form.getFieldsValue()).then(res => {
            messageApi.success('მონაცემები წარმატებით განახლდა');
            reload();
        }).catch(err => {
            messageApi.error(err?.response?.data || 'ვერ მოხერხდა მონაცემების განახლება');
        }).finally(() => {
            setEdit(false);
        });
    }
    const btnClick = () => {
        if (edit) {
            editProfileSave();
        } else {
            setEdit(true);
        }
    }
    return (
        <Card title='პროფილი'
            style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', height: '100%', padding: 20 }}
        >
            {contextHolder}
            <Row justify='center'>
                <Col xs={24} lg={12} xl={12}>
                    <Card
                        cover={
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 270, padding: 10 }}>
                                <Tooltip title='ავატარის ატვირთვა' color='blue'>
                                    <Button type='primary' shape='circle' icon={<i className="fa-solid fa-camera" style={{fontSize: 18}}></i>} style={{ position: 'absolute', top: 10, right: 10, }} />
                                </Tooltip>

                                <img src={require('../../assets/avatar.png')} alt='avatar' height={250} style={{ objectFit: 'contain', padding: 5, boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', borderRadius:15 }} />
                            </div>
                        }
                    >
                        <Meta
                            // title={'პროფილი'}
                            description={
                                <Form
                                    form={form}
                                    labelCol={{ span: 24 }}
                                    onFinish={editProfileSave}
                                >

                                    <Row gutter={[10, 5]} >
                                        <Col xs={24} md={12}>
                                            <Form.Item
                                                name='first_name'
                                                label='სახელი'
                                            >
                                                <Input style={styles.input} disabled={!edit} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item name='last_name' label='გვარი'>
                                                <Input style={styles.input} disabled={!edit} />
                                            </Form.Item>
                                        </Col>
                                        <Divider style={{ margin: 0, borderColor: 'rgba(0, 0, 0, 0.1)', borderWidth: 1 }} />
                                        <Col xs={24} md={12}>
                                            <Form.Item name='email' label='ელ-ფოსტა'>
                                                <Input disabled style={{ color: 'rgba(0, 0, 0, 1)' }} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item name='dob' label='დაბადების თარიღი'>
                                                <DatePicker format='DD/MM/YYYY' style={{ width: '100%', ...styles.input }} disabled={!edit} />
                                            </Form.Item>
                                        </Col>
                                        <Divider style={{ margin: 0, borderColor: 'rgba(0, 0, 0, 0.1)', borderWidth: 1 }} />
                                        <Col xs={24} md={12} style={{ display: 'flex', justifyContent: 'center', paddingTop: 21 }}>
                                            <ConfigProvider theme={{
                                                components: {
                                                    Button: {
                                                        colorPrimary: !edit ? '#2f54eb' : '#7cb305',
                                                        colorPrimaryHover: !edit ? '#10239e' : '#3f6600',
                                                        colorPrimaryActive: !edit ? '#061178' : '#3f6600',
                                                    },
                                                },
                                            }}>
                                                <Button type='primary' onClick={btnClick} style={{ width: 175 }} >
                                                    {!edit ? <i className="fa-solid fa-user-pen"> რედაქტირება</i> : <i className="fa-solid fa-floppy-disk"> შენახვა</i>}
                                                </Button>
                                            </ConfigProvider>
                                        </Col>
                                        <Col xs={24} md={12} style={{ display: 'flex', justifyContent: 'center', paddingTop: 21 }}>
                                            <ConfigProvider theme={{
                                                components: {
                                                    Button: {
                                                        colorPrimary: '#f5222d',
                                                        colorPrimaryHover: '#cf1322',
                                                        colorPrimaryActive: '#cf1322',
                                                    },
                                                },
                                            }}>
                                                <Button type='primary' onClick={() => { setPasswordChangeModal(true) }} style={{ width: 175 }} >
                                                    <i className="fa-solid fa-key"> პაროლის ცვლილება</i>
                                                </Button>
                                            </ConfigProvider>
                                        </Col>
                                    </Row>
                                </Form>
                            }
                        />
                    </Card>
                </Col>
            </Row>
            {
                passwordChangeModal && <PasswordChangeModal open={passwordChangeModal} close={setPasswordChangeModal} user_id={user_id} />
            }
        </Card>
    )
}

export const styles = {
    input: {
        color: 'rgba(0, 0, 0, 1)',
    },
}